import { render, staticRenderFns } from "./ebook.vue?vue&type=template&id=2905981f&scoped=true"
import script from "./ebook.vue?vue&type=script&lang=js"
export * from "./ebook.vue?vue&type=script&lang=js"
import style0 from "./ebook.vue?vue&type=style&index=0&id=2905981f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2905981f",
  null
  
)

export default component.exports